import React from 'react';

const IconMessage = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g stroke="#F8F8F8" clipPath="url(#clip0_2317_152)">
        <rect width="15" height="11" x="0.5" y="1.833" rx="1.5"></rect>
        <path d="M.664 4.667 7.997 8l7.334-3.333"></path>
      </g>
      <defs>
        <clipPath id="clip0_2317_152">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconMessage;
